export default __webpack_public_path__ + "static/media/Background_00121.e77a00f9.png";